"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.FONT_FAMILIES = void 0;
const constants_1 = require("./constants");
Object.defineProperty(exports, "FONT_FAMILIES", { enumerable: true, get: function () { return constants_1.FONT_FAMILIES; } });
exports.defaultTheme = {
    name: 'veepee',
    border: constants_1.BORDER,
    breakpoint: constants_1.BREAKPOINT,
    fontFamily: constants_1.FONT_FAMILIES,
    radius: constants_1.RADIUS,
    shadow: Object.assign(Object.assign({}, constants_1.SHADOW), { s100: '0 3px 11px 0 rgba(34,34,43,0.08)', s200: '0 3px 11px 0 rgba(34,34,43,0.16)', s300: '0 3px 11px 0 rgba(34,34,43,0.24)' }),
    space: constants_1.SPACING,
    typography: {
        display: {
            small: {
                fontFamily: constants_1.FONT_FAMILIES.condensed,
                fontWeight: 400,
                fontSize: '1.625rem',
                lineHeight: 'normal',
            },
            medium: {
                fontFamily: constants_1.FONT_FAMILIES.condensed,
                fontWeight: 400,
                fontSize: '2rem',
                lineHeight: 'normal',
            },
            large: {
                fontFamily: constants_1.FONT_FAMILIES.condensed,
                fontWeight: 400,
                fontSize: '2.375rem',
                lineHeight: '48px',
            },
            x_large: {
                fontFamily: constants_1.FONT_FAMILIES.condensed,
                fontWeight: 400,
                fontSize: '2.625rem',
                lineHeight: '50px',
            },
        },
        heading: {
            heading: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.625rem',
                lineHeight: 'normal',
            },
            small: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.125rem',
                lineHeight: '26px',
            },
            subheading: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.25rem',
                lineHeight: '26px',
            },
        },
        section: {
            bigTitle: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.5rem',
                lineHeight: 'normal',
            },
            subtitle: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.125rem',
                lineHeight: '22px',
            },
            title: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.25rem',
                lineHeight: '30px',
            },
        },
        body: {
            text: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 500,
                fontSize: '1rem',
                lineHeight: '23px',
            },
            textMain: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1rem',
                lineHeight: '23px',
            },
            boldText: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 600,
                fontSize: '1rem',
                lineHeight: '22px',
            },
            boldTextMain: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 700,
                fontSize: '1rem',
                lineHeight: '22px',
            },
            microText: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 500,
                fontSize: '0.625rem',
                lineHeight: '18px',
            },
            boldMicroText: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 600,
                fontSize: '0.625rem',
                lineHeight: '18px',
            },
            microTextMain: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '0.625rem',
                lineHeight: '18px',
            },
            boldMicroTextMain: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 700,
                fontSize: '0.625rem',
                lineHeight: '18px',
            },
            regularText: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 400,
                fontSize: '1rem',
                lineHeight: '23px',
            },
            regularTextMain: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 400,
                fontSize: '1rem',
                lineHeight: '23px',
            },
            smallText: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 500,
                fontSize: '0.875rem',
                lineHeight: '20px',
            },
            boldSmallText: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 600,
                fontSize: '0.875rem',
                lineHeight: '20px',
            },
            smallTextMain: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '0.875rem',
                lineHeight: '20px',
            },
            smallTextRegular: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 400,
                fontSize: '0.875rem',
                lineHeight: '18px',
            },
            boldSmallTextMain: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 700,
                fontSize: '0.875rem',
                lineHeight: '20px',
            },
            tinyText: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 500,
                fontSize: '0.75rem',
                lineHeight: '18px',
            },
            boldTinyText: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 600,
                fontSize: '0.75rem',
                lineHeight: '18px',
            },
            tinyTextMain: {
                fontFamily: constants_1.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '0.75rem',
                lineHeight: '18px',
            },
            tinyTextRegular: {
                fontFamily: constants_1.FONT_FAMILIES.text,
                fontWeight: 400,
                fontSize: '0.75rem',
                lineHeight: '18px',
            },
        },
        repairIndex: {
            secondaryBody: {
                fontFamily: constants_1.FONT_FAMILIES.marianne,
                fontWeight: 700,
                fontSize: '1.625rem',
                lineHeight: '100%',
            },
        },
    },
    colors: {
        css: {
            primary: 'invert(17%) sepia(65%) saturate(7253%) hue-rotate(314deg) brightness(90%) contrast(109%)',
            disabled: 'invert(78%) sepia(22%) saturate(3%) hue-rotate(235deg) brightness(98%) contrast(98%)',
            body: 'invert(26%) sepia(14%) saturate(374%) hue-rotate(201deg) brightness(93%) contrast(90%)',
            success: 'invert(22%) sepia(85%) saturate(3606%) hue-rotate(139deg) brightness(88%) contrast(97%)',
            error: 'invert(15%) sepia(100%) saturate(2761%) hue-rotate(350deg) brightness(97%) contrast(96%)',
            informative: 'invert(27%) sepia(75%) saturate(2099%) hue-rotate(162deg) brightness(95%) contrast(101%)',
            warning: 'invert(34%) sepia(65%) saturate(1318%) hue-rotate(3deg) brightness(90%) contrast(104%)',
        },
        primary: {
            primary: '#ec008c',
            dark: '#d90082',
            light: '#ea51a3',
        },
        secondary: {
            active: '#ec008c',
            backdrop: 'rgba(0, 0, 0, 0.5)',
        },
        neutral: constants_1.COLORS.neutral,
        gradient: constants_1.COLORS.gradient,
        business: constants_1.COLORS.business,
        main: {
            base: '#ec008c',
            tap: '#d90082',
            hover: '#ea51a3',
            focus: 'rgba(234,81,163,0.40)',
        },
        background: {
            primary: '#ffffff',
            secondary: '#ffffff',
        },
        accent: {
            base: '#ec008c',
        },
        discount: {
            base: constants_1.COLORS.functional.discount.savings,
            premium: constants_1.COLORS.functional.discount.savings,
            savings: constants_1.COLORS.functional.discount.savings,
        },
        guidedTour: {
            base: constants_1.COLORS.guidedTour.default,
        },
        text: {
            body: '#464650',
            title: '#22222b',
            alternate: {
                body: '#ffffff',
                title: '#ffffff',
            },
        },
        borders: {
            default: '#e1e1e4',
            hover: '#ec008c',
        },
        status: {
            ok: constants_1.COLORS.functional.success.default,
            error: constants_1.COLORS.functional.error.default,
            info: constants_1.COLORS.functional.informative.default,
            warn: constants_1.COLORS.functional.warning.default,
            pedagogical: constants_1.COLORS.functional.pedagocical.default,
            light: {
                ok: constants_1.COLORS.functional.success.light,
                error: constants_1.COLORS.functional.error.light,
                info: constants_1.COLORS.functional.informative.light,
                warn: constants_1.COLORS.functional.warning.light,
                pedagogical: constants_1.COLORS.functional.pedagocical.light,
            },
        },
        white: {
            s100: constants_1.COLORS.neutral.n0,
        },
        gray: {
            s200: constants_1.COLORS.neutral.n50,
            s300: constants_1.COLORS.neutral.n100,
            s400: constants_1.COLORS.neutral.n200,
            s500: constants_1.COLORS.neutral.n300,
            s600: constants_1.COLORS.neutral.n500,
            s650: constants_1.COLORS.neutral.n600,
            s700: constants_1.COLORS.neutral.n700,
            s800: constants_1.COLORS.neutral.n800,
            s900: constants_1.COLORS.neutral.n900,
        },
        green: {
            s50: constants_1.COLORS.functional.success.light,
            s75: constants_1.COLORS.functional.discount.savings,
            s100: constants_1.COLORS.functional.success.default,
        },
        orange: {
            s50: constants_1.COLORS.functional.warning.light,
            s100: constants_1.COLORS.functional.warning.default,
        },
        blue: {
            s50: constants_1.COLORS.functional.informative.light,
            s100: constants_1.COLORS.functional.informative.default,
        },
        red: {
            s50: constants_1.COLORS.functional.error.light,
            s75: '#E55253',
            s100: constants_1.COLORS.functional.error.default,
        },
        gold: {
            s50: constants_1.COLORS.functional.discount.premium,
        },
        utility: {
            success: '#3fae3e',
            error: '#ff0000',
            information: '#00a7ce',
            warning: '#f7ac00',
        },
        grayscale: {
            lightest: '#ffffff',
            lighter: '#f7f7f7',
            light: '#e1e1e4',
            gray: '#c8c8ca',
            medium: '#a2a2a7',
            medium_dark: '#75757a',
            dark: '#464650',
            darker: '#22222b',
            darkest: '#121217',
        },
        global: {
            green: '#3fae3e',
            green_light: '#ebf6eb',
            orange: '#f7ac00',
            orange_light: '#ffeec8',
            blue_light: '#d6ffff',
            red_light: '#ffd8d8',
        },
    },
    overrides: {
        price: {
            colors: {
                unavailable: {
                    primary: '#22222b',
                    secondary: '#75757a',
                },
            },
        },
        dropdown: {
            borderColors: {
                default: '#e1e1e4',
                hover: '#c8c8ca',
                disabled: '#e1e1e4',
            },
        },
    },
    variables: {
        breakpoints: {
            tablet_portrait: '641px',
            tablet_landscape: '769px',
            desktop: '1025px',
            desktop_large: '1221px',
        },
        fontFamily: {
            condensed: 'VP Condensed Next, Impact, arial, sans-serif',
            text: 'HK Grotesk, arial, sans-serif',
            title: 'VP Next, arial, sans-serif',
        },
        spacings: {
            component: {
                xxx_small: '2px',
                xx_small: '4px',
                x_small: '8px',
                small: '12px',
                default: '16px',
                medium: '24px',
                large: '32px',
                x_large: '40px',
                xx_large: '48px',
                xxx_large: '56px',
            },
            layout: {
                xx_small: '4px',
                x_small: '8px',
                small: '12px',
                default: '16px',
                medium: '24px',
                large: '32px',
                x_large: '40px',
                xx_large: '48px',
                xxx_large: '56px',
                xxxx_large: '64px',
                xxxxx_large: '72px',
                xxxxxx_large: '80px',
            },
        },
    },
};
exports.default = exports.defaultTheme;
